export default __webpack_public_path__ + "static/media/bu.e293a93d.jpg";